import React, { useEffect, useRef, useState } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { getAllVirtualTokenAsync, VirtualTokenActions } from "../redux";
import {
  Card,
  CardHeader,
  CardHeaderToolbar,
} from "./../../../../_metronic/_partials/controls";
import VirtualTokenTable from "./virtual_token_detail/virtualTokenTable";
import AddVirtualToken from "./virtual_token_detail/virtualTokenAdd";
import EditVirtualToken from "./virtual_token_detail/virtualTokenEdit";

export function VirtualTokenManagement() {
  const [showAddTemplate, setShowAddTemplate] = useState(false);
  const [showEditTemplete, setShowEditTemplate] = useState(false);
  const dispatch = useDispatch();
  const searchVirtualTokenRef = useRef();
  const type = "EMAIL";
  const { refreshTokenList, search, searchText } = useSelector(
    (state) => state.virtualTokenManagement,
    shallowEqual
  );
  //call api while search
  useEffect(() => {
    if (searchVirtualTokenRef.current) {
      let keyPressEvent = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          dispatch(VirtualTokenActions.refreshVirtualTokenList());
        }
      };
      let input = searchVirtualTokenRef.current;
      input.addEventListener("keyup", keyPressEvent);

      return () => {
        input.removeEventListener("keyup", keyPressEvent);
        dispatch(VirtualTokenActions.searchTextChange(""));
        input.value = "";
      };
    }
  }, []);
  useEffect(() => {
    if (refreshTokenList) {
      dispatch(getAllVirtualTokenAsync(search, searchText, type)); //call api for get email list
    }
  }, [refreshTokenList]);

  const onAddClick = () => {
    setShowAddTemplate(true);
  };
  //save edit email details
  const onEditClick = (email) => {
    dispatch(VirtualTokenActions.setSelectedVirtualToken(email));
    setShowEditTemplate(true);
  };
  //save search text
  const onSearchTextChange = (e) => {
    dispatch(VirtualTokenActions.searchTextChange(e.target.value));
  };

  return (
    <>
      <Card>
        <CardHeader title="Virtual Token Management">
          <CardHeaderToolbar>
            <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
              <form
                autoComplete="off"
                className="subheader_filter"
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="form-row">
                  <div className="form-group mr-5 mb-1 mt-2">
                    <button
                      className="btn_new btn-sm"
                      type="button"
                      onClick={() => onAddClick()}
                    >
                      Add
                    </button>
                  </div>
                  <div className="form-group mr-3 mb-1">
                    <input
                      name="Search"
                      placeholder="Search. . ."
                      type="text"
                      className="form-control"
                      value={searchText}
                      onChange={onSearchTextChange}
                      ref={searchVirtualTokenRef}
                    />
                  </div>
                </div>
              </form>
            </div>
          </CardHeaderToolbar>
        </CardHeader>
        <VirtualTokenTable onEditClick={onEditClick} />
        <AddVirtualToken
          setShowAddTemplate={setShowAddTemplate}
          showAddTemplate={showAddTemplate}
        />
        <EditVirtualToken
          showEditTemplete={showEditTemplete}
          setShowEditTemplate={setShowEditTemplate}
        />
      </Card>
    </>
  );
}
